<template>
  <div>
    <v-chart :force-fit="true" :height="size" :scale="scale" :animate="false" style="margin-left: -50px">
      <v-view :data="dataBackground" :animate="false">
        <v-coord
          type="polar"
          :startAngle="-202.5"
          :endAngle="22.5"
          :innerRadius="0.75"
          :radius="0.8"
        />
        <v-interval
          :position="'type*value'"
          :color="'#CBCBCB'"
          :size="2"
        />
      </v-view>
      <v-view :data="dataBackground" :scale="insideScale" :animate="false">
        <v-axis dataKey="value" :show="false" />
        <v-axis
          dataKey="type"
          :grid="null"
          :line="null"
          :tickLine="null"
          :label="insideAxisLabel"
        />
        <v-coord
          type="polar"
          :startAngle="-202.5"
          :endAngle="22.5"
          :innerRadius="0.95"
          :radius="0.55"
        />
        <v-interval
          :position="'type*value'"
          :color="'#CBCBCB'"
          :size="3"
        />
      </v-view>
      <v-view :data="dataFront" :animate="false">
        <v-coord
          :type="'polar'"
          :startAngle="-202.5"
          :endAngle="22.5"
          :innerRadius="0.75"
          :radius="0.8"
        />
        <v-interval
          :position="'type*value'"
          :color="frontIntervalColor"
          :opacity="1"
          :size="2"
        />
        <v-guide
          :type="'text'"
          :position="frontGuidePosition"
          :content="(datasource)+'%\r\n已完成'"
          :vStyle="frontGuideStyle"
        />
      </v-view>

      <v-view :data="[]" :animate="false">
        <v-guide
          :type="'text'"
          :position="['50%', '120%']"
          :content="description"
          :vStyle="{
      fill: 'rgba(0,0,0,0.8)',
  fontSize: 14,
           fontFamily:' sans-serif',
 textAlign: 'center',
  }"
        />
      </v-view>
      <v-view :data="[]" :animate="false">
        <v-guide
          :type="'text'"
          :position="['50%', '135%']"
          :content="description2"
          :vStyle="{
       fill: 'rgba(0,0,0,0.8)',
 fontSize: 16,
    textAlign: 'center',
    textBaseline: 'middle',
        fontFamily:' sans-serif',
  }"
        />
      </v-view>

    </v-chart>
  </div>
</template>

<script>
  const scale = [{
    dataKey: 'type',
    range: [0, 1],
  }, {
    dataKey: 'value',
    sync: true,
  }];

  const dataBackground = [];
  for (let i = 0; i < 50; i++) {
    const item = {
      type: i + '',
        value: 10,
    }
    if (i === 25) {
      item.value = 14;
    }
    dataBackground.push(item);

  }

  const insideScale = [{
    dataKey: 'type',
    tickCount: 3
  }];
  const insideAxisLabel = {
    offset: -15,
    textStyle: {
      textAlign: 'center',
      fill: '#CBCBCB',
      fontSize: 18
    },
    formatter: val => {
      if (val === '49') {
        return 100;
      }

      return val;
    }
  };

  // const frontIntervalColor = ['value', '#3023AE-#53A0FD'];
  const frontGuidePosition = ['50%', '60%'];
  const frontGuideStyle = {
    fill: 'black',
    fontFamily:'sans-serif',
    fontSize: 18,
    textAlign: 'center',
    textBaseline: 'middle',
  };
  export default {
    props:{
      size:{
        default:280
      },
      description:{
        default:'描述内容'
      },
      description2:{
        default:'描述内容2'
      },
      proColor:{
        default:'#1890FF'
      },
      datasource:{
        default:1
      }
    },
    data() {
      return {
        height: this.size,
        scale,
        dataBackground,
        dataFront:[{}],
        insideScale,
        insideAxisLabel,
        frontIntervalColor:['value',this.proColor],
        frontGuidePosition,
        frontGuideStyle,
        value:0,
      };
    },
    mounted(){
      this.value = parseFloat((this.datasource/2).toFixed(2))
      const dataFront = [];
      for (let i = 0; i < 50; i++) {
        const item = {
          type: i + '',
          value: 10,
        };
        if (i === parseInt(this.datasource / 2)) {
          item.value = 11;
        }
        if (i > parseInt(this.datasource / 2)) {
          item.value = 0;
        }
        dataFront.push(item);

      }
      this.dataFront = dataFront
    }
  };
</script>